import styled from "styled-components";
import { Button } from "@mui/material";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	word-break: break-word;

	> p {
		margin: 0;
	}
`;

export const TitleSupplierName = styled.p`
	> span {
		font-weight: bold;
	}
`;
export const TitleStatusChanged = styled.p`
	font-weight: bold;
`;

export const FileLink = styled(Button)`
	&&& {
		color: ${({ theme }) => theme.pantone2727C};
		padding: 0;
		margin: 0;
		min-width: fit-content;
		text-transform: none;

		> span {
			font-weight: bold;
			text-align: left;
			text-decoration: underline;
		}

		&:hover {
			filter: brightness(0.8);
		}
	}
`;

export const BoxFieldsChanged = styled.div`
	display: flex;
	flex-direction: column;
	gap: 5px;
	margin: 5px 0 0;

	p {
		margin: 0;
	}
`;

interface IListeFiles {
	margin: boolean;
}
export const ListFiles = styled.div<IListeFiles>`
	display: flex;
	flex-direction: column;
	gap: 0;
	margin: ${({ margin }) => (margin ? "5px 0 0" : "")};
`;
